export const appTitle = 'D 4 D';
export const titleSeparator = '|';

export default appTitle;



// WEBPACK FOOTER //
// ./src/config/helmetSettings.js